function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FunctionalLoader } from 'seagull';
import { compact } from 'lodash-es';
import { DeclarativeModal } from 'seagull';
import { selectors } from "../../store/state-selectors";
import { useOnMount } from "../../hooks/useOnMount";
import { useContacts } from "../../hooks/reactQuery/queries/useContacts";
import { useOverlayContext, useStore, useStoreActions, useStoreStatic } from "../../contexts";
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
import { AgreementStudioTemplateMode } from "./AgreementStudioTemplateMode";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function AgreementStudioTemplates(props) {
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    fetchAgreements,
    fetchProposals,
    fetchLegalTerms,
    fetchFinancialCentsUsers,
    fetchKarbonUsers
  } = useStoreActions();
  const {
    isLoading
  } = useContacts({
    refreshOnMount: true
  });
  const {
    getState
  } = useStoreStatic();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  useOnMount(() => {
    startLoader();
    const requests = compact([fetchLegalTerms(), fetchAgreements(), fetchProposals(), selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(), selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()]);
    Promise.all(requests).then(() => stopLoader());
  });
  if (!worksAt || !userEmail) throw makeSentryIgnoredError('noBusiness');
  return legalTermsDocuments ? /*#__PURE__*/_jsx(DeclarativeModal, {
    isOpen: true,
    content: () => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FunctionalLoader, {
        show: isLoading
      }), /*#__PURE__*/_jsx(AgreementStudioTemplateMode, _objectSpread(_objectSpread({}, props), {}, {
        template: props.template || null,
        legalTermsDocuments: legalTermsDocuments,
        worksAt: worksAt,
        userEmail: userEmail,
        onUploadLegalTermsDocument: fetchLegalTerms
      }))]
    })
  }) : /*#__PURE__*/_jsx(FunctionalLoader, {
    show: true
  });
}